// @module NXTurn.ShoppingExtensions.Carousel
define('C3.ShoppingExtensions.GroupAddToCart.RelatedItem.View'
,	[
	    'c3_shoppingextensions_groupaddtocart_related.tpl',
		'Backbone.CompositeView',
		//'Backbone.View',
		'Utils',
		'SCView'
    ]
, function (
		c3_shoppingextensions_groupaddtocart_related_tpl,
		BackboneCompositeView,
		//BackboneView,
		Utils,
	    SCViewModule
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

    function GroupAddToCartRelatedItemView (options) {
        SCView.call(this, options);

        //console.log(options)

        this.template = c3_shoppingextensions_groupaddtocart_related_tpl;
        this.options = options;
        this.model = options.model;
        this.application = options.application;

        BackboneCompositeView.add(this);

        this.showProductImage = function showProductImage(e)
	    {
	    	var $element = jQuery(e.currentTarget);
	    	var targetValue = $element.attr('data-item-id');
	    	jQuery("[data-item-image="+targetValue+"]").slideToggle();
	    }

	    this.contextDataRequest = ['item'];

	    this.validateContextDataRequest = function validateContextDataRequest()
	    {
	      return true;
	    }

	    /*this.contextData = function contextData(){
	    	return{
		        item: function() {
		            return Utils.deepCopy(this.model);
		        }
	        }
	    }*/

	    this.collapseAction = function collapseAction(e)
	    {
	    	var $element = jQuery(e.currentTarget);
	    	//console.log($element)
	    	//console.log($element.hasClass('collapsed'))
	    	
	    	if($element.hasClass('collapsed'))
	    	$element.removeClass('collapsed')
	    	else
	    	$element.addClass('collapsed')

	    	jQuery('.home-summary-expander-head-toggle').not($element).addClass('collapsed')
	    	jQuery('.home-summary-expander-container .collapse').not(this).collapse('hide');
	    	//jQuery('html, body').animate({ scrollTop: jQuery(this).offset().top }, 'slow');
	    	//jQuery(this).scrollIntoView();
	    }
    }

    GroupAddToCartRelatedItemView.prototype = Object.create(SCView.prototype);
    GroupAddToCartRelatedItemView.prototype.constructor = GroupAddToCartRelatedItemView;

    GroupAddToCartRelatedItemView.prototype.getEvents = function (){
    	return {
    		'click [data-action="show-addon-items"]': 'showAddOnItems',
			'click [data-action="show-image-please"]': 'showProductImage',
	    	'click [data-action="expand-div"]': 'collapseAction'
    	}
    }

    GroupAddToCartRelatedItemView.prototype.getChildViews = function (){
    	return {
    		'Item.Price': function() {
	            return new ProductViewsPriceView({
	                model: this.model,
	                origin: 'RELATEDITEM'
	            });
	        }
    	}
    }

    GroupAddToCartRelatedItemView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    GroupAddToCartRelatedItemView.prototype.getContext = function () {
    		var item_img = this.model.get('itemimages_detail')
			,   item_img_url = ''
			
			 if (!(_.isUndefined(item_img.urls)))
			 {
			 	item_img_url = item_img.urls[0]
			 	//console.log(item_img.urls[0])
			 }

			 var subcategory = this.model.get('custitem158') 

			 if(subcategory.indexOf('$$') > -1)
			 	subcategory = subcategory.slice(4)
			 
			// console.log(this.model.get('displayname'))
			// console.log(this.model.get('subitems'))
        return {
        		itemName: this.model.get('displayname') || this.model.Name,
	            subItems:this.model.get('subitems'),
	            uniqueNo:this.model.get('uniqueNo'),
	            // @property {ImageContainer} thumbnail
	           // thumbnail: this.model.getThumbnail(),
	            // @property {String} sku
	            sku: this.model.get('itemid'),
	            // @property {String} itemId
	            itemId: this.model.get('internalid'),
	            // @property {Item.Model} model
	            model: this.model,
	            subcategory: subcategory,
	            showSubCategory:this.model.get('showSubCategory'),
	            itemImageUrl : item_img_url,
	            // @property {Boolean} showRating
	            showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled,
	            // @property {String} track_productlist_list
	            track_productlist_list: this.model.get('track_productlist_list'),
	            // @property {String} track_productlist_position
	            track_productlist_position: this.model.get('track_productlist_position'),
	            // @property {String} track_productlist_category
	            track_productlist_category: this.model.get('track_productlist_category'),
	            safariBrowserMac : (typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1) ? true : false
        }
    }

    return GroupAddToCartRelatedItemView;

});
